// @flow @format
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import Loading from '../components/Loading';
import withFileNodeCache from '../hoc/withFileNodeCache';
import FileExplorer from '../components/FileExplorer';
import {FileListBody} from '../../../components/FileList';
import {encodeEmail} from 'lib/cloner-api/util';
import {openHistory} from '../../../reducers/history';
import {createDownload} from '../../../reducers/entities/downloads';
import {fetchFileVersions} from '../../../reducers/entities/files';

import type {FileNode, File} from 'lib/cloner-api';
import type {State as Store} from '../../../reducers';

type Props = {
	fileNode: ?FileNode,
	fileNodeId: string,
	usedBytes: number,
	grantedBytes: number,
	versions: {[fileId: string]: ?(File[])},
	showDeleted: boolean,
	createDownload: typeof createDownload,
	openHistory: typeof openHistory,
	fetchFileVersions: typeof fetchFileVersions,

	// router properties
	params: {repositoryId: string},
	location: {query: {userId: string, machineId: string}},
};

type State = {
	sortKey: $Keys<File>,
	sortLt: boolean,
};

class FileExplorerContainer extends PureComponent<Props, State> {
	state = {
		sortLt: true,
		sortKey: 'name',
	};

	_handleKeyChange = (key: $Keys<File>) => {
		if (this.state.sortKey === key) {
			this.setState({sortLt: !this.state.sortLt});
			return;
		}
		this.setState({sortKey: key, sortLt: true});
	};

	render() {
		if (!this.props.fileNode) {
			return (
				<FileListBody className="FilesLayout__Loading">
					<Loading
						className="FilesLayout__Spinner"
						title={`Cargando archivos...`}
					/>
				</FileListBody>
			);
		}

		const {userId, machineId} = this.props.location.query;
		const {repositoryId} = this.props.params;

		let files = this.props.fileNode.files || [];

		files = files
			.slice(1) // skip parent file
			.filter(file => this.props.showDeleted || !file.deleted)
			.sort((lhs, rhs) => {
				const comp = lhs.type - rhs.type;
				if (comp !== 0) {
					return comp;
				}
				const lval = lhs[this.state.sortKey];
				const rval = rhs[this.state.sortKey];

				if (typeof lval === 'string' && typeof rval === 'string') {
					return this.state.sortLt
						? lval.localeCompare(rval)
						: rval.localeCompare(lval);
				}

				if (typeof lval === 'number' && typeof rval === 'number') {
					return this.state.sortLt ? lval - rval : rval - lval;
				}

				return 0;
			});

		return (
			<FileExplorer
				{...this.state}
				files={files}
				usedBytes={this.props.usedBytes}
				grantedBytes={this.props.grantedBytes}
				versions={this.props.versions}
				fileNodeId={this.props.fileNodeId}
				onKeyChange={this._handleKeyChange}
				fileUrl={(fileId: string) =>
					`/explorer/files/${repositoryId}/${fileId}?userId=${encodeEmail(
						userId
					)}&machineId=${machineId}`}
				downloadFile={(fileId: string) => {
					this.props.openHistory();
					this.props.createDownload(fileId, repositoryId);
				}}
				fetchFileVersions={(fileId: string) => {
					this.props.fetchFileVersions(fileId, repositoryId);
				}}
			/>
		);
	}
}

const mapStateToProps = ({selection, entities}: Store) => {
	return {
		versions: entities.files.versions,
		fileNode: entities.files.entities[selection.fileNodeId],
		fileNodeId: selection.fileNodeId,
		showDeleted: entities.files.showDeleted,
		usedBytes: entities.downloads.usedBytes,
		grantedBytes: entities.downloads.grantedBytes,
	};
};

const mapDispatchToProps = {
	openHistory,
	createDownload,
	fetchFileVersions,
};

export default connect(mapStateToProps, mapDispatchToProps)(
	withFileNodeCache(FileExplorerContainer)
);



// WEBPACK FOOTER //
// ./src/routes/Explorer/containers/FileExplorerContainer.js